import Vue              from 'vue'
import Router           from 'vue-router'
import HelloWorld       from '@/components/HelloWorld'

import Index            from '@/pages/index/index'
import City             from '@/pages/index/city'
import History          from '@/pages/index/history'

import Maps             from '@/pages/index/maps'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    routes: [
        {
            path: '/',
            component: Index
        },{
            path: '/index/city',
            component: City
        },{
            path: '/index/history',
            component: History
        },{
            path: '/index/maps',
            component: Maps,
            meta: {
                title: "晋鑫仁和残疾人护航系统"
            }
        },
    ],
    state: {
        worktab: {
            list: [
                {
                    name: 'my',
                    tabname: '主页',
                    path: '/page/index/index'
                }
            ],
            current: {
                name: 'my',
                tabname: '主页',
                path: '/page/index/index'
            }
        },
        closingpage: ''
    },
    mutations: {
        worktabremove (state, p) {
            // 关闭标签
            let ind = state.worktab.list.findindex(s => s.name === p)
            if (ind > -1) {
                // 清理 keep alive - start
                state.closingpage = state.worktab.list[ind].name
                // 清理 keep alive - end
                state.worktab.list.splice(ind, 1)
            }
            if (p === state.worktab.current.name) {
                // 是当前页，返回上一页
                router.back()
            }
        },
        worktabroute (state, p) {
            let ind = state.worktab.list.findindex(s => s.name === p.to.name)
            if (ind > -1) {
                // 标签已存在
                state.worktab.current = state.worktab.list[ind]
            } else {
                // 标签不存在，现在新建
                state.worktab.list.push(p.to)
                state.worktab.current = p.to
            }
            state.closingpage = ''
        }
    },
    actions: {
        worktabremove ({commit}, p) {
            commit('worktabremove', p)
        },
        worktabroute ({commit}, p) {
            commit('worktabroute', p)
        }
    },

    // strict: debug
})



// WEBPACK FOOTER //
// ./src/router/index.js